export function buildUrlWithSearchParameters(baseUrl: string, parameters: Record<string, string>): string {
  const url = new URL(baseUrl)

  // Add or update query parameters
  Object.entries(parameters).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  return url.toString()
}
